import { render, staticRenderFns } from "./c-loading.vue?vue&type=template&id=ea1dc8d6&scoped=true&"
import script from "./c-loading.vue?vue&type=script&lang=js&"
export * from "./c-loading.vue?vue&type=script&lang=js&"
import style0 from "./c-loading.vue?vue&type=style&index=0&id=ea1dc8d6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea1dc8d6",
  null
  
)

export default component.exports